module.exports = __webpack_public_path__ + "img/gys_2@2x.7d0aed5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_2@2x.png
// module id = Dedz
// module chunks = 0